import React from 'react'
import styled, { css } from 'styled-components'
import { typography, colors } from "../styles"

const shared = css`
  display: inline-block;
  padding: ${ props => props.small ? '0.6em 1em' : '0.7em 1.3em'};
  ${typography.inherit.light}
  ${ props => props.small ? typography.p : typography.h3}
  border-radius: 0.25rem;
  background: ${colors.pinkText};
  border: 1px solid #DA005C;
  color: white;
  box-shadow: 0 0 8px -4px ${colors.pinkText};
  &:hover {
    box-shadow: inset 0 0 4px 2px #DA005C;
  }
`
const B = styled.button`
  ${shared}
  border: none;
`
const A = styled.a`
  ${shared}
  text-decoration: none;
`

const Button = ({ type = "button", children, ...props }) => (
  type === "anchor"
    ? <A {...props}>{children}</A>
    : <B {...props} type={type}>{children}</B>
)

export default Button



/** WEBPACK FOOTER **
 ** ./src/components/Button.js
 **/